import { useState, useMemo } from "react";
import DatetimePicker from "components/elements/dateTimePicker";
import SelectStaff from "components/elements/selectStaff";
import SelectShop from "components/elements/selectShop";
import { connect } from "react-redux";
import useCallApiUrl from "hook/useCallApiUrl";
import ShopData from "./shopData";
import Loading from "components/Loading";
import ChartProductPlatform from "./chartProductPlatform";
import ProductTotal from "./productTotal";

const ProductAnalytic = () => {
    const [filter, setFilter] = useState({});
    const [tablePaginate, setTablePaginate] = useState({
        offset: 0,
        limit: 10,
    });
    const [shopFilter, setShopFilter] = useState("");
    const searchOptions = useMemo(() => {
        return { ...filter, ...tablePaginate };
    }, [filter, tablePaginate]);
    const productTotalQuery = useMemo(
        () => ({ ...filter, ...(shopFilter ? { shop: shopFilter } : {}) }),
        [filter, shopFilter]
    );
    const { data, loading } = useCallApiUrl(
        "/api/analytic/total-by-shop",
        searchOptions,
        Object.keys(filter).length > 0
    );
    const { data: productPlf, loading: loadingPdf } = useCallApiUrl(
        "/api/analytic/product-platform",
        filter,
        Object.keys(filter).length > 0
    );
    const { data: productTotal, loading: loadingTotal } = useCallApiUrl(
        "/api/analytic/product",
        productTotalQuery,
        Object.keys(filter).length > 0
    );

    const handleTableChange = ({ page, limit }) => {
        setTablePaginate((prev) => ({ ...prev, offset: page - 1 ?? prev.page, limit: limit ?? prev.limit }));
    };

    return (
        <div className="d-flex flex-column gap-6" style={{ maxWidth: "1780px", margin: "auto" }}>
            <Loading isLoading={loading || loadingPdf || loadingTotal} />
            <div className="d-flex gap-2 mb-4">
                <DatetimePicker
                    onChange={(data) => setFilter((prev) => ({ ...prev, ...data }))}
                    typeDefault="last_week"
                />
                <SelectStaff onChange={(data) => setFilter((prev) => ({ ...prev, staff: data }))} />
            </div>
            <div className="card card-body">
                <div className="d-flex gap-4 justify-content-between align-items-center mb-4">
                    <h3>Analytic Products</h3>
                    <SelectShop onChange={(shop) => setShopFilter(shop)} />
                </div>
                <div className="row">
                    <ProductTotal data={productTotal || {}} />
                </div>

                <div className="mt-8">
                    <h3>Top Source Crawl</h3>
                    <ChartProductPlatform data={productPlf?.data || []} />
                </div>
            </div>

            <div className="card card-body">
                <ShopData
                    data={data?.data || []}
                    totalSize={data?.total || 0}
                    onTableChange={handleTableChange}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAnalytic);
